<template>
  <div class="order-list">
    <div class="order-list-search">
      <el-form
        label-width="80px"
        size="small"
        :model="searchForm"
      >
        <!-- <el-form-item label="工单号">
          <el-input v-model="searchForm.id"></el-input>
        </el-form-item>
        <el-form-item label="提交人">
          <el-input
            @change="test"
            v-model="searchForm.submit_user"
          ></el-input>
        </el-form-item>
        <el-form-item label="提交人手机号">
          <el-input v-model="searchForm.submit_user_phone"></el-input>
        </el-form-item> -->
        <el-form-item label="检索日期">
          <!-- <el-input
            v-model="searchForm.showDate"
            @focus="calendarShow = true"
          ></el-input> -->
          <div
            class="search-date"
            @click="calendarShow = true"
          >
            {{ searchForm.showDate }}
          </div>
          <van-calendar
            v-model="calendarShow"
            :min-date="new Date('2020-01-01')"
            :default-date="searchForm.date"
            :allow-same-day="true"
            type="range"
            @confirm="selectDate"
          />
        </el-form-item>
        <el-form-item label="检索内容">
          <el-input v-model="searchForm.filter"></el-input>
        </el-form-item>
      </el-form>
      <div class="order-list-search-btn">
        <el-button
          size="small"
          @click="formReset"
        >清空</el-button>
        <el-button
          type="primary"
          size="small"
          @click="workMyWorkList"
        >搜索</el-button>
      </div>

    </div>
    <div class="order-item-list">
      <van-pull-refresh
        v-model="refreshing"
        @refresh="onRefresh"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div
            v-for="item in orderList"
            :key="item.id"
            class="order-item"
            @click="goDetail(item)"
          >
            <div class="order-item-top">
              <span>
                {{ item.Title }}
              </span>
              <span class="">
                <el-tag
                  type="success"
                  v-if="item.AcceptStatus === 3"
                >{{item.AcceptStatusName}}</el-tag>
                <el-tag
                  type="warning"
                  v-else
                >{{ item.AcceptStatusName }}</el-tag>

              </span>
            </div>
            <div class="order-item-info">
              工单号:{{ item.Id }} {{ item.WorkTypeName }}-{{ item.CategoryName }}
            </div>
            <div class="order-item-info">
              提交人:{{ item.SubmitUser }} {{ item.SubmitUserPhone }} {{ item.SubmitTime }}
            </div>
            <!-- <div class="order-item-info">
            提交时间：{{ item.SubmitTime }}
          </div> -->
            <div class="order-item-info">
              客户:{{ item.ContactName }}{{ item.ContactPhone }} {{hisPatientEnumsMap.lst_member_grade_map && hisPatientEnumsMap.lst_member_grade_map[item.CustomerLevel]}}
            </div>
            <div
              v-if="item.FinishTime"
              class="order-item-info"
            >
              完成时间:{{ item.FinishTime }}
            </div>
          </div>

        </van-list>
      </van-pull-refresh>
    </div>

  </div>
</template>

<script>
import getUserInfo from "@/models/userInfo";
import workService from "@/apis/work/index.js";
import { getHisPatientEnums } from "@/models/customer";
import moment from "moment";
import { Loading } from "element-ui";
// import { Message } from "element-ui"

export default {
  data() {
    return {
      orderList: [],
      tableData: [],
      searchForm: {},
      loading: false,
      finished: false,
      refreshing: false,
      userInfo: {},
      hisPatientEnumsMap: {},
      calendarShow: false,
    };
  },
  watch: {
    "searchForm.date": {
      handler(newVal) {
        if (Array.isArray(newVal) && newVal.length > 0) {
          this.searchForm.showDate = `${moment(newVal[0]).format(
            "YYYY/MM/DD"
          )}-${moment(newVal[1]).format("YYYY/MM/DD")}`;
        } else {
          this.searchForm.showDate = "";
        }
      },
    },
  },
  components: {},
  async created() {
    const query = this.$route.query;
    this.initSearchForm();
    this.getHisPatientEnums();
    let userInfo = null;
    try {
      userInfo = await getUserInfo();
    } catch (e) {
      alert(e);
    }
    this.userInfo = JSON.parse(JSON.stringify(userInfo));
    // this.searchForm.submituser = userInfo.user_name;
    this.searchForm = {
      ...this.searchForm,
      submit_user: userInfo.user_name,
      submit_user_phone: userInfo.mobile,
      user_id: userInfo.user_id,
      filter: query.mobile,
    };
    // this.searchForm.submit_user_phone = userInfo.mobile;
    this.workMyWorkList();
  },
  methods: {
    formReset() {
      this.searchForm.filter = "";
    },
    initSearchForm() {
      console.log(moment());
      this.searchForm.date = [moment().subtract(7, "days")._d, moment()._d];
    },
    selectDate(date) {
      this.searchForm.date = date;
      this.calendarShow = false;
    },
    async workMyWorkList() {
      const { searchForm } = this;
      const params = {
        ...searchForm,
      };
      if (Array.isArray(searchForm.date) && searchForm.date.length > 0) {
        params.time_start = moment(searchForm.date[0]).format("YYYY-MM-DD");
        params.time_end = moment(searchForm.date[1]).format("YYYY-MM-DD");
      }
      this.loading = true;
      let loadingInstance = Loading.service({ fullscreen: true });
      workService
        .workMyWorkList(params)
        .then((res) => {
          this.orderList = res;
          console.log(res);
          this.loading = false;
          this.finished = true;
          this.refreshing = false;
          loadingInstance.close();
        })
        .catch((err) => {
          console.log(err);
          // Message({
          //   message: err.Message,
          //   type: "error",
          // })
        });
    },
    getHisPatientEnums() {
      getHisPatientEnums().then((res) => {
        this.hisPatientEnumsMap = res;
      });
    },
    onLoad() {
      // this.workMyWorkList();
    },
    onRefresh() {
      this.workMyWorkList();
    },
    test(value) {
      console.log(value);
    },
    onSubmit() {},
    goDetail(data) {
      console.log(data);
      const query = this.$route.query;
      this.$router.push({
        name: "WorkOrderDetail",
        query: {
          ...query,
          id: data.Id,
          type: data.CategoryId === 155 ? "complaint" : "normal",
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.order-list {
  padding: 10px 20px 0 20px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .van-pull-refresh {
    // height: 100%;
    // flex: 1;
  }
}
.order-list-search {
  margin-bottom: 5px;
  flex-shrink: 0;
  .search-date {
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    padding: 0 15px;
  }
  .el-form {
    // display: flex;
    // justify-content: space-between;
  }
  .el-form-item {
    // text-align: center;
    // width: 48%;
    // display: flex;
    margin-bottom: 10px;
  }
  .el-form-item__label {
    // line-height: 20px;
  }
  .el-button {
    width: 100%;
  }
}
.order-list-search-btn {
  display: flex;
}
.order-item-list {
  flex: 1;
  overflow-y: auto;
}
.order-item {
  .order-item-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .order-item-status {
    flex: 0 0 60px;
    line-height: 20px;
    font-size: 12px;
    text-align: center;
    border-radius: 2px;
    box-sizing: border-box;
    color: #f1b82c;
    border: 1px solid #ffe6a9;
    background-color: #fff9ec;
  }
  .order-item-info {
    margin-top: 5px;
  }
}
</style>
<style lang="scss">
.order-list-search {
  .el-form-item__label {
    // line-height: 20px;
    padding-bottom: 0;
  }
}
.van-list {
  // height: 100%;
}
.order-item {
  box-sizing: border-box;
  padding: 4px 20px;
  border-radius: 8px;
  background: #fff;
  margin-bottom: 5px;
  font-size: 12px;
}
</style>